import { INotificationItem, NotificationItemMutation } from '../../../interfaces';

export const resolveMutation = (notification: INotificationItem): NotificationItemMutation => ({
    id: notification.id,
    action: notif => ({ ...notif, ...notification, loaded: true }),
});
